const chlo = process.env.VUE_APP_CLINICA === "chlo" && import('../assets/orozco.css')
const cqc = process.env.VUE_APP_CLINICA === "cqc" && import('../assets/colosio.css')
const sandbox = process.env.VUE_APP_CLINICA === "sandbox" && import('../assets/sandbox.css')

export const css = cqc ? cqc : chlo? chlo : sandbox